export const isAdmin = (u) => !!u?.isAdmin;
export const isLeadership = (u) => isAdmin(u) || u?.role === 'Leadership';
export const canViewAllProjects = (u) => isLeadership(u);
export const canManageUsers = (u) => isAdmin(u);
export const canAssumeIdentity = (u) => isAdmin(u) || u?.role === 'Leadership';
